import FilmQuizBrokenHeartSvg from 'src/components/svg/FilmQuizBrokenHeartSvg';
import FilmQuizHeartSvg from 'src/components/svg/FilmQuizHeartSvg';
import styled from 'src/lib/styles/css';

//#region [Props]
type LivesProps = {
	livesLeft: number;
};
//#endregion

//#region [Component]
export default function Lives({ livesLeft }: LivesProps) {

	return <SLivesLeft>
		<SLeftLabel>Antall liv:</SLeftLabel>
		{[...Array(livesLeft)].map((h, idx) => <FilmQuizHeartSvg key={`life-${idx}`} />)}
		{[...Array(3 - livesLeft)].map((h, idx) => <FilmQuizBrokenHeartSvg key={`unlife-${idx}`} />)}
	</SLivesLeft>;
}
//#endregion

//#region [Styles]
const SLivesLeft = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    color: #857efe; /*NB: Ikke i designmanualen*/

    margin-bottom: 20px;
    margin-top: 10px;

    svg {
        margin-right: 3px;
    }
`;

const SLeftLabel = styled.span`
	margin-right: 5px;
`;


//#endregion